import {
  ItemToVerifyType
} from '@generated/graphql';
import {BaseModel} from '@shared/models/base.model';
import {OfficerRequiredDocument} from "@modules/officer/models/officer-required-document.model";
import {OfficerDocument} from "@modules/officer/models/officer-document.model";
import {CompanyStakeholder} from "@modules/company/models/company-stakeholder.model";
import {companyStakeholderFactory} from "@modules/company/factories/company-stakeholder.factory";

export class ItemToVerify extends BaseModel implements ItemToVerifyType{
  id!: string;
  stakeholder: CompanyStakeholder;
  missingKycDocuments: OfficerRequiredDocument[];
  verifyingKycDocuments: OfficerDocument[]

  constructor(state: ItemToVerifyType) {   
    super(state);
    this.stakeholder = companyStakeholderFactory.tryCreating(state.stakeholder)
  }

  getModelName(): string {
    return "";
  }
}
